// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/fonts/Gilroy-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/fonts/Gilroy-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.DetailModal_modal__hG\\+FT {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 990px;
}
.DetailModal_modal__hG\\+FT .DetailModal_titleContainer__uDlWr {
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: 16px;
}
.DetailModal_modal__hG\\+FT .DetailModal_header__NQsiM {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.DetailModal_modal__hG\\+FT .DetailModal_header__NQsiM button {
  position: absolute;
  bottom: 0;
}
.DetailModal_modal__hG\\+FT .DetailModal_toggleContainer__atFlC {
  display: flex;
  width: 100%;
  border-bottom: 1px solid rgba(20, 16, 41, 0.12);
  border-radius: 1px 1px 0px 0px;
  position: relative;
  margin-bottom: 8px;
}
.DetailModal_modal__hG\\+FT .DetailModal_active__N499o {
  font-weight: 600;
  font-family: "semi-Montserrat";
}
.DetailModal_modal__hG\\+FT .DetailModal_notActive__QydWO {
  font-weight: 500;
  font-family: "med-Montserrat";
}
.DetailModal_modal__hG\\+FT .DetailModal_activeBorder__r0B0e {
  height: 2px;
  background-color: #5d2de1;
  position: absolute;
  bottom: -1px;
  transition: all 0.2s;
}
.DetailModal_modal__hG\\+FT .DetailModal_container__BlO85 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  background-color: var(--bg-color);
}
.DetailModal_modal__hG\\+FT .DetailModal_card__Z-EjX {
  background: rgba(235, 239, 245, 0.6);
  border-radius: 24px;
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.DetailModal_modal__hG\\+FT .DetailModal_card__Z-EjX h3 {
  color: rgba(20, 16, 41, 0.8);
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  font-family: "semi-Montserrat";
}
.DetailModal_modal__hG\\+FT .DetailModal_card__Z-EjX form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.DetailModal_modal__hG\\+FT .DetailModal_card__Z-EjX .DetailModal_rowForm__XLgef {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
.DetailModal_modal__hG\\+FT .DetailModal_card__Z-EjX .DetailModal_rowForm__XLgef .DetailModal_colContainer__7tssU {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 416px;
  gap: 24px;
}
@media (max-width: 650px) {
  .DetailModal_modal__hG\\+FT .DetailModal_card__Z-EjX .DetailModal_rowForm__XLgef {
    flex-direction: column;
  }
}
.DetailModal_modal__hG\\+FT .DetailModal_card__Z-EjX .DetailModal_inpContainer__xpKDt {
  height: 48px;
  width: 100%;
}
.DetailModal_modal__hG\\+FT .DetailModal_halfWidth__0-Eez {
  max-width: 440px;
}
.DetailModal_modal__hG\\+FT .DetailModal_fullWidth__Ok6zn {
  max-width: 100%;
}
.DetailModal_modal__hG\\+FT .DetailModal_switchContainer__Ef2Sl {
  background: rgba(20, 16, 41, 0.03);
  border-radius: 12px;
  padding: 14px 12px;
}
.DetailModal_modal__hG\\+FT .DetailModal_viewBtn__5ac\\+t {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 3;
}
.DetailModal_modal__hG\\+FT .DetailModal_infoContainer__JHrup {
  background: rgba(20, 16, 41, 0.03);
  border-radius: 12px;
  padding: 8px 12px;
}
.DetailModal_modal__hG\\+FT .DetailModal_infoContainer__JHrup span {
  display: block;
}
.DetailModal_modal__hG\\+FT .DetailModal_infoContainer__JHrup .DetailModal_key__FYT9b {
  color: rgba(20, 16, 41, 0.8);
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  font-family: "med-Montserrat";
}
.DetailModal_modal__hG\\+FT .DetailModal_infoContainer__JHrup .DetailModal_value__t7ypI {
  color: rgba(20, 16, 41, 0.8);
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  font-family: "med-Montserrat";
}
.DetailModal_modal__hG\\+FT .DetailModal_paymentContainer__dQQQt {
  display: flex;
  justify-content: space-between;
  gap: 24px;
}
.DetailModal_modal__hG\\+FT .DetailModal_paymentContainer__dQQQt .DetailModal_cardInp__vLaGN {
  width: 100%;
  max-width: 272px;
}
.DetailModal_modal__hG\\+FT .DetailModal_paymentContainer__dQQQt .DetailModal_expInp__JGcwW {
  width: 100%;
  max-width: 96px;
}
.DetailModal_modal__hG\\+FT .DetailModal_paymentContainer__dQQQt .DetailModal_stateInp__pRYNV {
  width: 100%;
  max-width: 296px;
}
.DetailModal_modal__hG\\+FT .DetailModal_paymentContainer__dQQQt .DetailModal_number__2nYol {
  font-family: "med-gilory";
}
.DetailModal_modal__hG\\+FT .DetailModal_btns__CHNNB {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
}
.DetailModal_modal__hG\\+FT .DetailModal_btns__CHNNB button {
  max-width: 188px;
  width: 100%;
}
.DetailModal_modal__hG\\+FT .DetailModal_btns__CHNNB .DetailModal_delete__RxzM5 {
  background-color: rgba(20, 16, 41, 0.03);
}
.DetailModal_modal__hG\\+FT .DetailModal_btns__CHNNB .DetailModal_delete__RxzM5:hover {
  background-color: #141029;
}
.DetailModal_modal__hG\\+FT .DetailModal_methodsContainer__iucJf {
  display: flex;
  flex-direction: column;
  height: 328px;
  overflow: auto;
  gap: 16px;
}
.DetailModal_modal__hG\\+FT .DetailModal_methodContainer__9Zrej {
  background: rgba(20, 16, 41, 0.03);
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  cursor: pointer;
}
.DetailModal_modal__hG\\+FT .DetailModal_methodContainer__9Zrej img {
  width: 24px;
}
.DetailModal_modal__hG\\+FT .DetailModal_methodContainer__9Zrej span {
  color: rgba(20, 16, 41, 0.8);
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  font-family: "semi-Montserrat";
}
.DetailModal_modal__hG\\+FT .DetailModal_activeMethod__C1nCA {
  outline: solid 2px #5d2de1;
  outline-offset: -5px;
}
.DetailModal_modal__hG\\+FT .DetailModal_largeTexts__3CKnA button {
  font-size: 12px;
}
.DetailModal_modal__hG\\+FT .DetailModal_addNew__15wb1 {
  margin-left: auto;
}
@media (max-width: 650px) {
  .DetailModal_modal__hG\\+FT .DetailModal_addNew__15wb1 {
    margin-left: initial;
  }
}
.DetailModal_modal__hG\\+FT .DetailModal_walletsContainer__Sogb5 {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.DetailModal_modal__hG\\+FT .DetailModal_walletsContainer__Sogb5 button {
  background: rgba(20, 16, 41, 0.03);
  border-radius: 12px;
  padding: 10px;
}
.DetailModal_modal__hG\\+FT .DetailModal_walletsContainer__Sogb5 img {
  width: 36px;
}
.DetailModal_modal__hG\\+FT .DetailModal_marginTopBtn__wTRB0 {
  margin-top: 88px;
}
@media (max-width: 550px) {
  .DetailModal_modal__hG\\+FT {
    padding: 40px 16px 32px;
  }
  .DetailModal_modal__hG\\+FT .DetailModal_titleContainer__uDlWr h2 {
    font-size: 24px;
    line-height: 28px;
  }
  .DetailModal_modal__hG\\+FT .DetailModal_marginTopBtn__wTRB0 {
    margin-top: 0;
  }
}

.DetailModal_methodsContainer__iucJf::-webkit-scrollbar {
  width: 12px;
}

.DetailModal_methodsContainer__iucJf::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 9999px;
  background-color: #aaaaaa;
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/_variables.scss","webpack://./src/components/Layouts/DetailModal/DetailModal.module.scss"],"names":[],"mappings":"AA4CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,8BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,8BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,6BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,yBAAA;EACA,4CAAA;AC3CF;AAlCA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAoCJ;AAnCI;EACI,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAqCR;AAnCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAqCR;AAnCQ;EACI,kBAAA;EACA,SAAA;AAqCZ;AAlCI;EACI,aAAA;EACA,WAAA;EACA,+CAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAoCR;AAlCI;EACI,gBDIG;ECHH,8BDoDgB;AChBxB;AAlCI;EACI,gBDDK;ECEL,6BDiDe;ACbvB;AAlCI;EACI,WAAA;EACA,yBD5CQ;EC6CR,kBAAA;EACA,YAAA;EACA,oBAAA;AAoCR;AAlCI;EACI,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,iCAAA;AAoCR;AAlCI;EACI,oCAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAoCR;AAlCQ;EACI,4BD/DM;ECgEN,gBD5BD;EC6BC,eD/CG;ECgDH,iBDvCK;ECwCL,8BDkBY;ACkBxB;AAlCQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAoCZ;AAlCQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAoCZ;AAnCY;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EAEA,SAAA;AAoChB;AAlCY;EAZJ;IAaQ,sBAAA;EAqCd;AACF;AAlCQ;EACI,YAAA;EACA,WAAA;AAoCZ;AAjCI;EACI,gBAAA;AAmCR;AAjCI;EACI,eAAA;AAmCR;AAjCI;EACI,kCAAA;EACA,mBAAA;EACA,kBAAA;AAmCR;AAjCI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAmCR;AAjCI;EACI,kCAAA;EACA,mBAAA;EACA,iBAAA;AAmCR;AAlCQ;EACI,cAAA;AAoCZ;AAlCQ;EACI,4BDzHM;EC0HN,gBDvFC;ECwFD,eAAA;EACA,iBAAA;EACA,6BDvCW;AC2EvB;AAlCQ;EACI,4BDhIM;ECiIN,gBD9FC;EC+FD,eDnHG;ECoHH,iBD1GK;EC2GL,6BD9CW;ACkFvB;AAjCI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAmCR;AAlCQ;EACI,WAAA;EACA,gBAAA;AAoCZ;AAlCQ;EACI,WAAA;EACA,eAAA;AAoCZ;AAlCQ;EACI,WAAA;EACA,gBAAA;AAoCZ;AAlCQ;EACI,yBD9Da;ACkGzB;AAjCI;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;AAmCR;AAlCQ;EACI,gBAAA;EACA,WAAA;AAoCZ;AAlCQ;EACI,wCAAA;AAoCZ;AAnCY;EACI,yBD1KH;AC+Mb;AAjCI;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;AAmCR;AAjCI;EACI,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AAmCR;AAlCQ;EACI,WAAA;AAoCZ;AAlCQ;EACI,4BD/LM;ECgMN,gBD5JD;EC6JC,eDlLG;ECmLH,iBDzKK;EC0KL,8BD9GY;ACkJxB;AAjCI;EACI,0BAAA;EACA,oBAAA;AAmCR;AAhCQ;EACI,eAAA;AAkCZ;AA/BI;EACI,iBAAA;AAiCR;AAhCQ;EAFJ;IAGQ,oBAAA;EAmCV;AACF;AAjCI;EACI,aAAA;EACA,SAAA;EACA,eAAA;AAmCR;AAlCQ;EACI,kCAAA;EACA,mBAAA;EACA,aAAA;AAoCZ;AAlCQ;EACI,WAAA;AAoCZ;AAjCI;EACI,gBAAA;AAmCR;AAjCI;EApOJ;IAqOQ,uBAAA;EAoCN;EAnCM;IACI,eDpNG;ICqNH,iBD7MK;ECkPf;EAnCM;IACI,aAAA;EAqCV;AACF;;AAlCA;EACI,WAAA;AAqCJ;;AAlCA;EACI,kCAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;AAqCJ","sourcesContent":["// colors\n$primary-color: #5d2de1;\n$dark-color: #141029;\n$cultured-color: #f5f7fa;\n$dark-text-color: rgba(20, 16, 41, 0.8);\n$white-color: #ffffff;\n$card-gradient-color: linear-gradient(\n  135deg,\n  #ffffff 0%,\n  #fafbfc 51.82%,\n  #f5f7fa 100%\n);\n$pink-color: #e0e0ff;\n$white-color-40: rgba(255, 255, 255, 0.4);\n$white-color-4: rgba(224, 224, 255, 0.04);\n$danger-color: #f54562;\n\n// fonts\n\n$font-size-xs: 13px;\n$font-size-sm: 14px;\n$font-size-md: 16px;\n$font-size-xm: 18px;\n$font-size-lg: 20px;\n$font-size-xl: 24px;\n$font-size-xxl: 30px;\n$font-size-3xl: 36px;\n$font-size-4xl: 48px;\n\n$font-height-xs: 16px;\n$font-height-sm: 20px;\n$font-height-md: 24px;\n$font-height-xm: 28px;\n$font-height-lg: 30px;\n$font-height-xl: 32px;\n$font-height-xxl: 36px;\n$font-height-3xl: 40px;\n$font-height-4xl: 48px;\n\n$font-light: 500;\n$font-med: 600;\n$font-bold: 700;\n$font-extra: 800;\n\n@font-face {\n  font-family: \"bold-Poppins\";\n  src: url(/assets/fonts/Poppins-Bold.ttf);\n}\n@font-face {\n  font-family: \"bold-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Bold.ttf);\n}\n@font-face {\n  font-family: \"semi-Poppins\";\n  src: url(/assets/fonts/Poppins-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"semi-Montserrat\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-Poppins\";\n  src: url(/assets/fonts/Poppins-Medium.ttf);\n}\n@font-face {\n  font-family: \"med-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Medium.ttf);\n}\n@font-face {\n  font-family: \"bold-gilory\";\n  src: url(/assets/fonts/Gilroy-Bold.ttf);\n}\n@font-face {\n  font-family: \"extra-gilory\";\n  src: url(/assets/fonts/Gilroy-ExtraBold.otf);\n}\n@font-face {\n  font-family: \"semi-gilory\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-gilory\";\n  src: url(/assets/fonts/Gilroy-Medium.ttf);\n}\n\n$title-font-family-bold: \"bold-Poppins\";\n$title-font-family-semi: \"semi-Poppins\";\n$title-font-family-med: \"med-Poppins\";\n$text-font-family-bold: \"bold-Montserrat\";\n$text-font-family-semi: \"semi-Montserrat\";\n$text-font-family-med: \"med-Montserrat\";\n$number-font-family-bold: \"bold-gilory\";\n$number-font-family-extra: \"extra-gilory\";\n$number-font-family-semi: \"semi-gilory\";\n$number-font-family-med: \"med-gilory\";\n\n// dark and light theme\n$dark-bg-color: #111315; // background\n$dark-sb-bg-color: #242527; // sidebar\n\n$light-bg-color: #F4F4F4; // background\n$light-sb-bg-color: #FCFCFC; // sidebar","@import \"/src/assets/stylesheets/variables\";\n\n\n\n\n.modal {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    max-width: 990px;\n    .titleContainer {\n        background-color: transparent;\n        display: flex;\n        align-items: center;\n        gap: 16px;\n    }\n    .header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        button {\n            position: absolute;\n            bottom: 0;\n        }\n    }\n    .toggleContainer {\n        display: flex;\n        width: 100%;\n        border-bottom: 1px solid rgba(20, 16, 41, 0.12);\n        border-radius: 1px 1px 0px 0px;\n        position: relative;\n        margin-bottom: 8px;\n    }\n    .active {\n        font-weight: $font-med;\n        font-family: $text-font-family-semi;\n    }\n    .notActive {\n        font-weight: $font-light;\n        font-family: $text-font-family-med;\n    }\n    .activeBorder {\n        height: 2px;\n        background-color: $primary-color;\n        position: absolute;\n        bottom: -1px;\n        transition: all 0.2s;\n    }\n    .container {\n        display: flex;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        gap: 16px;\n        background-color: var(--bg-color);\n    }\n    .card {\n        background: rgba(235, 239, 245, 0.6);\n        border-radius: 24px;\n        padding: 20px 24px 24px;\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        width: 100%;\n\n        h3 {\n            color: $dark-text-color;\n            font-weight: $font-med;\n            font-size: $font-size-xm;\n            line-height: $font-height-md;\n            font-family: $text-font-family-semi;\n        }\n        form {\n            display: flex;\n            flex-direction: column;\n            gap: 24px;\n        }\n        .rowForm {\n            display: flex;\n            flex-direction: row;\n            gap: 16px;\n            .colContainer {\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                max-width: 416px;\n\n                gap: 24px;\n            }\n            @media (max-width: 650px) {\n                flex-direction: column;\n            }\n        }\n\n        .inpContainer {\n            height: 48px;\n            width: 100%;\n        }\n    }\n    .halfWidth {\n        max-width: 440px;\n    }\n    .fullWidth {\n        max-width: 100%;\n    }\n    .switchContainer {\n        background: rgba(20, 16, 41, 0.03);\n        border-radius: 12px;\n        padding: 14px 12px;\n    }\n    .viewBtn {\n        position: absolute;\n        right: 12px;\n        top: 12px;\n        z-index: 3;\n    }\n    .infoContainer {\n        background: rgba(20, 16, 41, 0.03);\n        border-radius: 12px;\n        padding: 8px 12px;\n        span {\n            display: block;\n        }\n        .key {\n            color: $dark-text-color;\n            font-weight: $font-light;\n            font-size: 10px;\n            line-height: 12px;\n            font-family: $text-font-family-med;\n        }\n        .value {\n            color: $dark-text-color;\n            font-weight: $font-light;\n            font-size: $font-size-xs;\n            line-height: $font-height-xs;\n            font-family: $text-font-family-med;\n        }\n    }\n    .paymentContainer {\n        display: flex;\n        justify-content: space-between;\n        gap: 24px;\n        .cardInp {\n            width: 100%;\n            max-width: 272px;\n        }\n        .expInp {\n            width: 100%;\n            max-width: 96px;\n        }\n        .stateInp {\n            width: 100%;\n            max-width: 296px;\n        }\n        .number {\n            font-family: $number-font-family-med;\n        }\n    }\n    .btns {\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        gap: 16px;\n        button {\n            max-width: 188px;\n            width: 100%;\n        }\n        .delete {\n            background-color: rgba(20, 16, 41, 0.03);\n            &:hover {\n                background-color: $dark-color;\n            }\n        }\n    }\n    .methodsContainer {\n        display: flex;\n        flex-direction: column;\n        height: 328px;\n        overflow: auto;\n        gap: 16px;\n    }\n    .methodContainer {\n        background: rgba(20, 16, 41, 0.03);\n        border-radius: 12px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 12px;\n        cursor: pointer;\n        img {\n            width: 24px;\n        }\n        span {\n            color: $dark-text-color;\n            font-weight: $font-med;\n            font-size: $font-size-xs;\n            line-height: $font-height-xs;\n            font-family: $text-font-family-semi;\n        }\n    }\n    .activeMethod {\n        outline: solid 2px $primary-color;\n        outline-offset: -5px;\n    }\n    .largeTexts {\n        button {\n            font-size: 12px;\n        }\n    }\n    .addNew {\n        margin-left: auto;\n        @media (max-width: 650px) {\n            margin-left: initial;\n        }\n    }\n    .walletsContainer {\n        display: flex;\n        gap: 16px;\n        flex-wrap: wrap;\n        button {\n            background: rgba(20, 16, 41, 0.03);\n            border-radius: 12px;\n            padding: 10px;\n        }\n        img {\n            width: 36px;\n        }\n    }\n    .marginTopBtn {\n        margin-top: 88px;\n    }\n    @media (max-width: 550px) {\n        padding: 40px 16px 32px;\n        .titleContainer h2 {\n            font-size: $font-size-xl;\n            line-height: $font-height-xm;\n        }\n        .marginTopBtn {\n            margin-top: 0;\n        }\n    }\n}\n.methodsContainer::-webkit-scrollbar {\n    width: 12px;\n}\n\n.methodsContainer::-webkit-scrollbar-thumb {\n    border: 4px solid rgba(0, 0, 0, 0);\n    background-clip: padding-box;\n    border-radius: 9999px;\n    background-color: #aaaaaa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `DetailModal_modal__hG+FT`,
	"titleContainer": `DetailModal_titleContainer__uDlWr`,
	"header": `DetailModal_header__NQsiM`,
	"toggleContainer": `DetailModal_toggleContainer__atFlC`,
	"active": `DetailModal_active__N499o`,
	"notActive": `DetailModal_notActive__QydWO`,
	"activeBorder": `DetailModal_activeBorder__r0B0e`,
	"container": `DetailModal_container__BlO85`,
	"card": `DetailModal_card__Z-EjX`,
	"rowForm": `DetailModal_rowForm__XLgef`,
	"colContainer": `DetailModal_colContainer__7tssU`,
	"inpContainer": `DetailModal_inpContainer__xpKDt`,
	"halfWidth": `DetailModal_halfWidth__0-Eez`,
	"fullWidth": `DetailModal_fullWidth__Ok6zn`,
	"switchContainer": `DetailModal_switchContainer__Ef2Sl`,
	"viewBtn": `DetailModal_viewBtn__5ac+t`,
	"infoContainer": `DetailModal_infoContainer__JHrup`,
	"key": `DetailModal_key__FYT9b`,
	"value": `DetailModal_value__t7ypI`,
	"paymentContainer": `DetailModal_paymentContainer__dQQQt`,
	"cardInp": `DetailModal_cardInp__vLaGN`,
	"expInp": `DetailModal_expInp__JGcwW`,
	"stateInp": `DetailModal_stateInp__pRYNV`,
	"number": `DetailModal_number__2nYol`,
	"btns": `DetailModal_btns__CHNNB`,
	"delete": `DetailModal_delete__RxzM5`,
	"methodsContainer": `DetailModal_methodsContainer__iucJf`,
	"methodContainer": `DetailModal_methodContainer__9Zrej`,
	"activeMethod": `DetailModal_activeMethod__C1nCA`,
	"largeTexts": `DetailModal_largeTexts__3CKnA`,
	"addNew": `DetailModal_addNew__15wb1`,
	"walletsContainer": `DetailModal_walletsContainer__Sogb5`,
	"marginTopBtn": `DetailModal_marginTopBtn__wTRB0`
};
export default ___CSS_LOADER_EXPORT___;
